export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/bool',
		name: 'NbuBool',
		title: {
			single: 'NbuBool',
			plural: 'NbuBools'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "T",
				"code": null,
				"name": "Так",
				"caption": "Так",
				"isBlocked": false
			},
			{
				"id": "F",
				"code": null,
				"name": "Ні",
				"caption": "Ні",
				"isBlocked": false
			}
		],
	},
}
